import { UserDto } from 'booksprout'
import { AuthenticationState } from './types'
import { defineState } from '../../../base/store/defineState'

export const defaultState = (): AuthenticationState => ({
  csrfToken: '',
  user: new UserDto(),
  token: {
    data: '',
    expires: 0
  },
  mimicUser: new UserDto(),
  termsConsentNeeded: false,
  termsConsentFailed: false,
  termsConsentData: {
    emailAddress: '',
    password: '',
    extendLogin: true,
    loginResult: void 0
  },
  authExpired: false
})

export const resetAuthenticationState = () => {
  return defaultState()
}

/**
 * Request-scoped on the server, which matters more here than anywhere else: app-reviewer's
 * routeGuard boot file is not marked `server: false`, so it runs AUTH_LOAD against the incoming
 * request's cookies during SSR. A module-level singleton would hand one visitor's session to
 * another's render.
 */
export default defineState<AuthenticationState>('authentication', defaultState)
